import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableSuratPemberitahuan } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  usePagination,
} from "../../../components";
import {
  Box,
  Typography,
  Divider,
  Pagination,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";

function dhm(t) {
  var cd = 24 * 60 * 60 * 1000,
    ch = 60 * 60 * 1000,
    d = Math.floor(t / cd),
    h = Math.floor((t - d * cd) / ch),
    m = Math.round((t - d * cd - h * ch) / 60000),
    pad = function (n) {
      return n < 10 ? "0" + n : n;
    };
  if (m === 60) {
    h++;
    m = 0;
  }
  if (h === 24) {
    d++;
    h = 0;
  }
  return d;
}

const TampilSuratPemberitahuan = () => {
  const { setting, user } = useContext(AuthContext);
  const { dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };
  const [isFetchError, setIsFetchError] = useState(false);
  const [isSpsExist, setIsSpsExist] = useState(false);
  const [noJual, setNoJual] = useState("");
  const [namaRegister, setNamaRegister] = useState("");
  const [almRegister, setAlmRegister] = useState("");
  const [tlpRegister, setTlpRegister] = useState("");
  const [tglAng, setTglAng] = useState("");
  const [angsuranKe, setAngsuranKe] = useState("");
  const [tenor, setTenor] = useState("");
  const [bulan, setBulan] = useState("");
  const [sisaBulan, setSisaBulan] = useState("");
  const [tglSpDate, setTglSpDate] = useState("");
  const [callfee, setCallfee] = useState("");
  const [tglSp, setTglSp] = useState("");
  const [spKe, setSpKe] = useState("");
  const [isBayar, setIsBayar] = useState("");

  const [kodeKolektor, setKodeKolektor] = useState("");
  const [tipe, setTipe] = useState("");
  const [noRangka, setNoRangka] = useState("");
  const [tahun, setTahun] = useState("");
  const [namaWarna, setNamaWarna] = useState("");
  const [nopol, setNopol] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [spsData, setSpsData] = useState([]);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const PER_PAGE = 20;

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const tempPosts = spsData.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (
      val.noJual.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.idJual.namaRegister
        .toUpperCase()
        .includes(searchTerm.toUpperCase()) ||
      val.idJual.almRegister.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.idJual.tglAng.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.tglSp.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.idJual.nopol.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.cabang.toUpperCase().includes(searchTerm.toUpperCase())
    ) {
      return val;
    }
  });
  const currentPosts = tempPosts.slice(indexOfFirstPost, indexOfLastPost);

  const count = Math.ceil(tempPosts.length / PER_PAGE);
  const _DATA = usePagination(spsData, PER_PAGE);

  useEffect(() => {
    id ? getSpById() : setIsSpsExist(false);
  }, [id]);

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI") {
      getSpAllCabangsData();
    } else {
      getSpsData();
    }
  }, [page, searchTerm]);

  const getSpAllCabangsData = async () => {
    setLoading(true);
    try {
      const allSps = await axios.post(
        `${tempUrl}/spsAllCabangPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuery(searchTerm);
      setSpsData(allSps.data.suratPemberitahuans);
      setPage(allSps.data.page);
      setPages(allSps.data.totalPage);
      setRows(allSps.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSpsData = async () => {
    setLoading(true);
    try {
      const allSps = await axios.post(
        `${tempUrl}/spsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        },
      );
      setQuery(searchTerm);
      setSpsData(allSps.data.suratPemberitahuans);
      setPage(allSps.data.page);
      setPages(allSps.data.totalPage);
      setRows(allSps.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getSpById = async () => {
    setLoading(true);
    if (id) {
      const response = await axios.post(`${tempUrl}/sps/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsSpsExist(true);
      setNoJual(response.data.noJual);
      setNamaRegister(response.data.idJual.namaRegister);
      setAlmRegister(response.data.idJual.almRegister);
      setTlpRegister(response.data.idJual.tlpRegister);
      setTenor(response.data.idJual.tenor);
      setBulan(response.data.idJual.tenor - response.data.idJual.sisaBulan);
      setSisaBulan(response.data.idJual.sisaBulan);
      setTglSpDate(new Date(response.data.tglSp));
      setCallfee(response.data.callfee);
      setTglSp(formatDate(response.data.tglSp));
      setSpKe(response.data.spKe);
      setIsBayar(response.data.isBayar);

      setKodeKolektor(
        `${response.data.kodeKolektor.kodeKolektor} - ${response.data.kodeKolektor.namaKolektor}`,
      );
      setTipe(response.data.idJual.tipe);
      setNoRangka(response.data.idJual.noRangka);
      setTahun(response.data.idJual.tahun);
      setNamaWarna(response.data.idJual.namaWarna);
      setNopol(response.data.idJual.nopol);

      const allAngsuransByNoJual = await axios.post(
        `${tempUrl}/angsuransByNoJualAllCabang`,
        {
          noJual: response.data.noJual,
          id: user._id,
          token: user.token,
        },
      );
      setTglAng(
        formatDate(
          allAngsuransByNoJual.data.angsuran[response.data.angsuranKe - 1]
            .tglJatuhTempo,
        ),
      );
      setAngsuranKe(response.data.angsuranKe);
    }
    setLoading(false);
  };

  const deleteSp = async (id) => {
    try {
      setLoading(true);
      // Find Jual
      const findJualByNoJual = await axios.post(`${tempUrl}/jualByNoJual`, {
        noJual,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      await axios.post(`${tempUrl}/deleteSpAndUpdateJual`, {
        jualData: {
          noJual,
          idJual: findJualByNoJual.data._id,
          spKe: findJualByNoJual.data.spKe - 1,
          tglSpTerakhir: "",
          kodeCabang: user.cabang._id,
          id: user._id,
          token: user.token,
        },
        spData: {
          idSp: id,
          kodeCabang: user.cabang._id,
          id: user._id,
          token: user.token,
        },
        kodeCabang: user.cabang._id,
        id: user._id,
        token: user.token,
      });
      setNoJual("");
      setNamaRegister("");
      setAlmRegister("");
      setTglAng("");
      setTenor("");
      setBulan("");
      setSisaBulan("");
      setTglSp("");
      setCallfee("");
      setSpKe("");
      setIsBayar("");

      setKodeKolektor("");
      setTipe("");
      setNoRangka("");
      setTahun("");
      setNamaWarna("");
      setNopol("");
      setLoading(false);
      navigate("/suratPemberitahuan");
      getSpsData();
    } catch (error) {
      console.log(error);
    }
  };

  const hapusCallfeeJual = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/hapusCallfeeJual/${id}`, {
        kodeCabang: user.cabang._id,
        id: user._id,
        token: user.token,
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const munculkanCallfeeJual = async () => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/munculkanCallfeeJual/${id}`, {
        kodeCabang: user.cabang._id,
        id: user._id,
        token: user.token,
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // const downloadPdf = async () => {
  //   let tempY = 52;
  //   let tempDateName;
  //   let date = new Date();
  //   var tempTglAng = new Date(tglSpDate);
  //   switch (tempTglAng.getMonth() + 1) {
  //     case 1:
  //       tempDateName = "JANUARI";
  //       break;
  //     case 2:
  //       tempDateName = "FEBRUARI";
  //       break;
  //     case 3:
  //       tempDateName = "MARET";
  //       break;
  //     case 4:
  //       tempDateName = "APRIL";
  //       break;
  //     case 5:
  //       tempDateName = "MEI";
  //       break;
  //     case 6:
  //       tempDateName = "JUNI";
  //       break;
  //     case 7:
  //       tempDateName = "JULI";
  //       break;
  //     case 8:
  //       tempDateName = "AGUSTUS";
  //       break;
  //     case 9:
  //       tempDateName = "SEPTEMBER";
  //       break;
  //     case 10:
  //       tempDateName = "OKTOBER";
  //       break;
  //     case 11:
  //       tempDateName = "NOVEMBER";
  //       break;
  //     case 12:
  //       tempDateName = "DESEMBER";
  //       break;
  //     default:
  //       break;
  //   }

  //   var tempDate;
  //   const response = await axios.post(`${tempUrl}/angsuransChildTunggak`, {
  //     tglInput: date,
  //     noJual,
  //     id: user._id,
  //     token: user.token,
  //     kodeCabang: user.cabang._id,
  //   });

  //   const doc = new jsPDF();
  //   doc.setFontSize(9);
  //   doc.text(
  //     `${setting.lokasiSP} / ${tempTglAng.getDate().toLocaleString("en-US", {
  //       minimumIntegerDigits: 2,
  //       useGrouping: false,
  //     })} ${tempDateName} ${tempTglAng.getFullYear()}`,
  //     15,
  //     tempY
  //   );
  //   tempY += 6;
  //   doc.text(`Kepada Yth.`, 15, tempY);
  //   doc.setFont(undefined, "bold");
  //   doc.text(`: Bpk / Ibu ${namaRegister}`, 44, tempY);
  //   tempY += 6;
  //   doc.text(`${almRegister}`, 46, tempY);
  //   doc.setFont(undefined, "normal");
  //   tempY += 11;
  //   doc.text(`Perihal`, 15, tempY);
  //   doc.text(`: SURAT PEMBERITAHUAN TUNGGAKAN ${spKe}`, 44, tempY);
  //   tempY += 9;
  //   doc.text(`Dengan Hormat,`, 15, tempY);
  //   tempY += 6;
  //   doc.text(
  //     `Untuk menghindari biaya penarikan sepeda motor No. Polisi ${nopol} dengan ini kami`,
  //     15,
  //     tempY
  //   );
  //   tempY += 6;
  //   doc.text(
  //     `sampaikan bahwa sepeda motor Bapak/Ibu telah menunggak ${response.data.length} bulan, dengan rincian sbb :`,
  //     15,
  //     tempY
  //   );
  //   tempY += 6;
  //   for (let i = 0; i < response.data.length; i++) {
  //     tempDate = new Date(response.data[i].tglJatuhTempo);

  //     switch (tempDate.getMonth() + 1) {
  //       case 1:
  //         tempDateName = "JANUARI";
  //         break;
  //       case 2:
  //         tempDateName = "FEBRUARI";
  //         break;
  //       case 3:
  //         tempDateName = "MARET";
  //         break;
  //       case 4:
  //         tempDateName = "APRIL";
  //         break;
  //       case 5:
  //         tempDateName = "MEI";
  //         break;
  //       case 6:
  //         tempDateName = "JUNI";
  //         break;
  //       case 7:
  //         tempDateName = "JULI";
  //         break;
  //       case 8:
  //         tempDateName = "AGUSTUS";
  //         break;
  //       case 9:
  //         tempDateName = "SEPTEMBER";
  //         break;
  //       case 10:
  //         tempDateName = "OKTOBER";
  //         break;
  //       case 11:
  //         tempDateName = "NOVEMBER";
  //         break;
  //       case 12:
  //         tempDateName = "DESEMBER";
  //         break;
  //       default:
  //         break;
  //     }

  //     var dt = new Date(response.data[i].tglJatuhTempo);
  //     let day = dt.getDate().toLocaleString("en-US", {
  //       minimumIntegerDigits: 2,
  //       useGrouping: false,
  //     });
  //     let month = (dt.getMonth() + 1).toLocaleString("en-US", {
  //       minimumIntegerDigits: 2,
  //       useGrouping: false,
  //     });
  //     let sum = day + "-" + month + "-" + dt.getFullYear();

  //     doc.text(`${i + 1}.  Angsuran ke ${i + 1}`, 30, tempY);
  //     doc.text(`Bulan ${tempDateName} ${tempDate.getFullYear()}`, 70, tempY);
  //     doc.text(`( ${sum} )`, 120, tempY);
  //     doc.text(`Rp.`, 150, tempY);
  //     doc.text(
  //       `${response.data[i].angPerBulan.toLocaleString("en-US")}`,
  //       180,
  //       tempY,
  //       {
  //         align: "right",
  //       }
  //     );
  //     tempY += 6;
  //   }
  //   tempY += 1;
  //   doc.text(`Jumlah di atas belum termasuk denda tunggakan.`, 15, tempY);
  //   tempY += 10;
  //   doc.text(
  //     `Demikian Surat Pemberitahuan ini kami sampaikan kepada Bapak/Ibu, dan kami menunggu`,
  //     15,
  //     tempY
  //   );
  //   tempY += 6;
  //   doc.text(
  //     `3 hari dari surat ini diterbitkan. Apabila dalam 3 hari Bapak/Ibu tidak datang ke kantor,`,
  //     15,
  //     tempY
  //   );
  //   tempY += 6;
  //   doc.text(
  //     `maka kami akan mengambil kembali sepeda motor tersebut.`,
  //     15,
  //     tempY
  //   );
  //   tempY += 8;
  //   doc.text(`Atas kerjasamanya kami ucapkan terimakasih.`, 15, tempY);
  //   tempY += 6;
  //   doc.text(`Hormat kami,`, 15, tempY);
  //   tempY += 24;
  //   doc.text(`${setting.namaPemilik}`, 15, tempY);
  //   doc.setFontSize(12);
  //   window.open(URL.createObjectURL(doc.output("blob")));
  // };

  const downloadPdf = async () => {
    let tempYTitle = 20;
    let tempY = 35;
    let tempDateName;
    let date = new Date();
    var tempTglAng = new Date(tglSpDate);
    switch (tempTglAng.getMonth() + 1) {
      case 1:
        tempDateName = "JANUARI";
        break;
      case 2:
        tempDateName = "FEBRUARI";
        break;
      case 3:
        tempDateName = "MARET";
        break;
      case 4:
        tempDateName = "APRIL";
        break;
      case 5:
        tempDateName = "MEI";
        break;
      case 6:
        tempDateName = "JUNI";
        break;
      case 7:
        tempDateName = "JULI";
        break;
      case 8:
        tempDateName = "AGUSTUS";
        break;
      case 9:
        tempDateName = "SEPTEMBER";
        break;
      case 10:
        tempDateName = "OKTOBER";
        break;
      case 11:
        tempDateName = "NOVEMBER";
        break;
      case 12:
        tempDateName = "DESEMBER";
        break;
      default:
        break;
    }

    var tempDate;
    const response = await axios.post(`${tempUrl}/angsuransChildTunggak`, {
      angsuranKe,
      tglInput: date,
      noJual,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });

    // const doc = new jsPDF();
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm", // keep mm
      format: [241.3, 279.4], // 24.13cm=241.3mm, 27.94cm=279.4mm
    });
    doc.setFontSize(20);
    doc.setFont(undefined, "bold");
    doc.text(`SURAT PEMBERITAHUAN`, 60, tempYTitle);
    doc.setFont(undefined, "normal");
    // doc.setFontSize(11);
    doc.setFontSize(11);
    doc.text(
      `${setting.lokasiSP}, ${tempTglAng.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })} ${tempDateName} ${tempTglAng.getFullYear()}`,
      15,
      tempY,
    );
    tempY += 9;
    doc.text(`Kepada Yth, Bapak / Ibu `, 15, tempY);
    doc.setFont(undefined, "bold");
    // doc.text(`${namaRegister} / ${noJual}`, 60, tempY);
    doc.text(`${namaRegister} / ${noJual}`, 80, tempY);
    doc.setFont(undefined, "normal");
    tempY += 6;
    doc.text(`Di ${almRegister}`, 15, tempY);
    tempY += 6;
    doc.text(`( ${tlpRegister} )`, 15, tempY);
    tempY += 12;
    doc.text(`Dengan hormat,`, 15, tempY);
    tempY += 6;
    doc.text(
      `Bersama dengan ini kami sampaikan, bahwa Bapak / Ibu telah lalai melakukan pembayaran sewa`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(
      `sepeda motor dan untuk menghindari dari biaya pengambilan kembali sepeda motor, dengan ini`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(
      `kami sampaikan bahwa Bapak / Ibu telah menunggak ${
        response.data.length
      } ( ${angkaTerbilang(
        response.data.length,
      )} ) bulan sewa sepeda motor ${nopol}`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(`dengan rincian sbb :`, 15, tempY);
    tempY += 6;
    for (let i = 0; i < response.data.length; i++) {
      tempDate = new Date(response.data[i].tglJatuhTempo);

      switch (tempDate.getMonth() + 1) {
        case 1:
          tempDateName = "JANUARI";
          break;
        case 2:
          tempDateName = "FEBRUARI";
          break;
        case 3:
          tempDateName = "MARET";
          break;
        case 4:
          tempDateName = "APRIL";
          break;
        case 5:
          tempDateName = "MEI";
          break;
        case 6:
          tempDateName = "JUNI";
          break;
        case 7:
          tempDateName = "JULI";
          break;
        case 8:
          tempDateName = "AGUSTUS";
          break;
        case 9:
          tempDateName = "SEPTEMBER";
          break;
        case 10:
          tempDateName = "OKTOBER";
          break;
        case 11:
          tempDateName = "NOVEMBER";
          break;
        case 12:
          tempDateName = "DESEMBER";
          break;
        default:
          break;
      }

      var dt = new Date(response.data[i].tglJatuhTempo);
      let day = dt.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      let month = (dt.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      let sum = day + "-" + month + "-" + dt.getFullYear();

      var d1 = new Date(tglSpDate); //"now"
      d1.setHours(0, 0, 0, 0);
      let d1Month = (d1.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      var d2 = new Date(response.data[i].tglJatuhTempo); // some date
      d2.setHours(0, 0, 0, 0);
      let d2Month = (d2.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      var diff = Math.abs(d1 - d2); // difference in milliseconds
      var total = dhm(diff);
      let keterlambatan = 0;
      if (d1 > d2) {
        keterlambatan = total;
      }
      if (d1Month != d2Month) {
        keterlambatan = new Date(
          d2.getFullYear(),
          parseInt(d2Month),
          0,
        ).getDate();
      }
      let tempDenda =
        ((response.data[i].angPerBulan * setting.dendaPersenSetting) / 100) *
        keterlambatan;
      let tempHutangDenda = response.data[i].hutangDenda;
      if (response.data[i].hutangDenda < 0) {
        tempHutangDenda = 0;
      }

      doc.text(`${i + 1}.  Angsuran ke ${response.data[i]._id}`, 30, tempY);
      doc.text(`bulan ${tempDateName} ${tempDate.getFullYear()}`, 70, tempY);
      doc.text(`( ${sum} )`, 120, tempY);
      doc.text(`Rp.`, 150, tempY);
      doc.text(
        `${response.data[i].angPerBulan.toLocaleString("en-US")}`,
        180,
        tempY,
        {
          align: "right",
        },
      );
      tempY += 6;
      doc.text(`Denda (${setting.dendaPersenSetting}%/hari)`, 35, tempY);
      doc.text(
        `: Rp. ${tempDenda.toLocaleString("en-US")} (${keterlambatan} hari)`,
        90,
        tempY,
      );
      tempY += 6;
      doc.text(`Hutang Denda`, 35, tempY);
      doc.text(`: Rp. ${tempHutangDenda.toLocaleString("en-US")}`, 90, tempY);
      tempY += 6;
      doc.text(`Call Fee`, 35, tempY);
      doc.text(`: Rp. ${callfee.toLocaleString("en-US")}`, 90, tempY);
      tempY += 6;
      let tempTotalHarusDibayar =
        tempDenda +
        tempHutangDenda +
        parseInt(callfee) +
        parseInt(response.data[i].angPerBulan) +
        parseInt(response.data[i].denda);
      doc.text(`TOTAL harus dibayar`, 35, tempY);
      doc.text(
        `: Rp. ${tempTotalHarusDibayar.toLocaleString("en-US")}`,
        90,
        tempY,
      );
      tempY += 6;
    }
    tempY += 1;
    doc.text(
      `Jumlah di atas akan bertambah sesuai dengan denda keterlambatan.`,
      15,
      tempY,
    );
    tempY += 10;
    doc.text(
      `Demikian surat pemberitahuan ini kami sampaikan kepada Bapak /Ibu , dan kami menunggu`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(
      `pembayaran sewa sepeda motor tersebut dari surat ini diterima. Apabila Bapak /Ibu belum`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(
      `menyelesaikan pembayaran sesuai kesepakatan awal , maka akan dikenakan denda sebesar`,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(
      `Rp 200.000,- (dua ratus ribu rupiah). Untuk menghindari denda Rp 200.000,- tersebut, `,
      15,
      tempY,
    );
    tempY += 6;
    doc.text(`disarankan untuk menitipkan sepeda motor tersebut.`, 15, tempY);
    tempY += 8;
    doc.text(`Atas kerjasamanya kami ucapkan terimakasih.`, 15, tempY);
    tempY += 14;
    if (tempY < 200) {
      tempY += 50;
    }
    doc.text(`Hormat kami,`, 15, tempY);
    doc.text(`Diterima oleh,`, 130, tempY);
    tempY += 35;
    doc.text(`Tanggal : ${tglSp}`, 130, tempY);
    doc.setFontSize(12);
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Surat Pemberitahuan
      </Typography>
      {isSpsExist && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={() => downloadPdf()}>
              CETAK
            </Button>
          </ButtonGroup>
        </Box>
      )}
      <Box sx={buttonModifierContainer}>
        {user.tipeUser !== "OWN/DIREKSI" && (
          <ButtonModifier
            id={id}
            kode={isSpsExist}
            addLink={`/suratPemberitahuan/tambahSuratPemberitahuan`}
            editLink={`/suratPemberitahuan/${id}/edit`}
            deleteUser={deleteSp}
            nameUser={noJual}
          />
        )}
      </Box>
      <Box sx={buttonModifierContainer}>
        {isSpsExist && isBayar === false && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              sx={{ bgcolor: "primary.light", textTransform: "none" }}
              size="small"
              onClick={() => hapusCallfeeJual()}
            >
              Hapus Callfee
            </Button>
            <Button
              color="secondary"
              sx={{ bgcolor: "secondary.light", textTransform: "none" }}
              size="small"
              onClick={() => munculkanCallfeeJual()}
            >
              Munculkan Callfee
            </Button>
          </ButtonGroup>
        )}
      </Box>
      <Divider sx={dividerStyle} />
      {isSpsExist && (
        <>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Jual :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noJual} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={namaRegister} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={almRegister} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tgl. Angsuran :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tglAng} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Angs. / Bulan / Sisa :
                    </Form.Label>
                    <Col sm={3}>
                      <Form.Control value={tenor} disabled />
                    </Col>
                    <Col sm={2}>
                      <Form.Control value={bulan} disabled />
                    </Col>
                    <Col sm={3}>
                      <Form.Control value={sisaBulan} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tgl. Sp / Ke :
                    </Form.Label>
                    <Col sm={4}>
                      <Form.Control value={tglSp} disabled />
                    </Col>
                    <Col sm={4}>
                      <Form.Control value={spKe} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Callfee :
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        value={callfee.toLocaleString("en-US")}
                        disabled
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Eksekutor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeKolektor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tipe :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tipe} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Rangka :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noRangka} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nopol :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={nopol} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tahun / Warna :
                    </Form.Label>
                    <Col sm={4}>
                      <Form.Control value={tahun} disabled />
                    </Col>
                    <Col sm={4}>
                      <Form.Control value={namaWarna} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Divider sx={dividerStyle} />
        </>
      )}
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      {spsData && (
        <Box sx={tableContainer}>
          <ShowTableSuratPemberitahuan
            // currentPosts={currentPosts}
            // searchTerm={searchTerm}
            // tipeUser={user.tipeUser}

            currentPosts={spsData}
            tipeUser={user.tipeUser}
          />
        </Box>
      )}
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilSuratPemberitahuan;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
